module.exports = __webpack_public_path__ + "static/karolina-avatar-012a95d35937c00db807336da97f1074.webp";